module.exports = __webpack_public_path__ + "img/pin.009f0d7a.svg";